import focus from '../../../input/border-color/focus';

export default focus;
